import React, { useCallback, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTriggerResizeSelector } from '@Services/CommonStatus/Selector';

const DEFAULT_TEXTAREA_HEIGHT = 20;

const TextArea = ({ value, placeholder, onChange, onFocus }) => {
  const textAreaRef = useRef(null);
  const { resizeTrigger } = useSelector(useTriggerResizeSelector);
  const handleResizeHeight = useCallback(() => {
    if (textAreaRef === null || textAreaRef.current === null) {
      return;
    }

    textAreaRef.current.style.height = `${DEFAULT_TEXTAREA_HEIGHT}px`;
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
  }, []);

  useEffect(() => {
    handleResizeHeight();
  }, [resizeTrigger]);

  return (
    <TextAreaWrapper>
      <StyledTextArea
        ref={textAreaRef}
        rows={1}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onInput={handleResizeHeight}
        onFocus={onFocus}
      />
    </TextAreaWrapper>
  );
};

TextArea.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

TextArea.defaultProps = {
  onFocus: () => {},
};

const TextCSS = css`
  font-family: 'KoPubBatang_Pro';

  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes.lg}px;
  color: ${({ theme }) => theme.colors.ui_on_1};

  line-height: 27px;
  letter-spacing: -0.57px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.ui_on_3};
  }
`;

const TextAreaWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: 'transparent';
`;

const StyledTextArea = styled.textarea`
  ${TextCSS}

  display: flex;
  resize: none;
  overflow: hidden;
  outline: none;
  border: none;
  padding: 0px;
  background-color: 'transparent';

  width: 100%;
  min-height: ${DEFAULT_TEXTAREA_HEIGHT}px;
`;

export default TextArea;
